/** Big statement after the showreel — one entry per line */
export const statementLines = ['Most brands get scrolled past.', 'Ours get explored.'];
